import { MapPin, Phone, Clock, ExternalLink } from "lucide-react";
import { CLINICS } from "@/lib/data";

export default function Clinics() {
  return (
    <section id="clinics" data-testid="clinics-section" className="section">
      <div className="container-page">
        <div className="max-w-3xl">
          <p className="label-eyebrow">Visit Us</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-forest mt-5 leading-[1.05]">
            Two clinics in Birpara, <span className="italic text-terracotta">one standard of care.</span>
          </h2>
          <p className="mt-6 text-lg text-forest/70 leading-relaxed">
            Both locations offer the same compassionate consultation. Both clinics are also attached to <span className="text-forest font-medium">Maa Nursing Home</span> for 24×7 inpatient care when needed.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {CLINICS.map((c) => (
            <div key={c.id} data-testid={`clinic-${c.id}`} className="card-soft overflow-hidden">
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/7789616/pexels-photo-7789616.jpeg"
                  alt={c.name}
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>
              <div className="p-8 md:p-10">
                <p className="label-eyebrow">Clinic</p>
                <h3 className="font-serif text-3xl md:text-4xl text-forest mt-3">{c.name}</h3>
                <ul className="mt-6 space-y-3 text-forest/80">
                  <li className="flex items-start gap-3"><MapPin className="w-5 h-5 text-sage mt-0.5 shrink-0" strokeWidth={1.5} /> {c.address}</li>
                  <li className="flex items-start gap-3"><Clock className="w-5 h-5 text-sage mt-0.5 shrink-0" strokeWidth={1.5} /> <span>{c.hours}<br/><span className="text-forest/55 text-sm">{c.closed}</span></span></li>
                  <li className="flex items-start gap-3">
                    <Phone className="w-5 h-5 text-sage mt-0.5 shrink-0" strokeWidth={1.5} />
                    <a href={`tel:${c.phone.replace(/\s/g, "")}`} data-testid={`clinic-${c.id}-call`} className="hover:text-terracotta transition-colors">{c.phone}</a>
                  </li>
                </ul>

                <div className="mt-8 flex flex-wrap gap-3">
                  <a href={c.mapsLink} target="_blank" rel="noreferrer" data-testid={`clinic-${c.id}-directions`} className="btn-outline h-11 text-sm">
                    <ExternalLink className="w-4 h-4" strokeWidth={1.5} /> Get Directions
                  </a>
                  <a href={`tel:${c.phone.replace(/\s/g, "")}`} className="btn-primary h-11 text-sm">
                    <Phone className="w-4 h-4" strokeWidth={1.5} /> Call Clinic
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
